var map = {
	"./assets/Images/30102023.jpg": 3747,
	"./assets/Images/Asia-Villaico.ico": 8201,
	"./assets/Images/PHOTO-2021-10-26-11-35-13 (1).jpg": 7449,
	"./assets/Images/noimage.jpg": 2599,
	"./assets/Images/ourstory.jpg": 7873,
	"./assets/Images/welcomeasia.png": 5909,
	"./assets/Photos/Menu01042024/appetiser_salt_pepper_chicken.jpeg": 7261,
	"./assets/Photos/Menu01042024/appretiser_chicken_gyoza.jpeg": 185,
	"./assets/Photos/Menu01042024/appretiser_duck_spring_rolls.jpeg": 8877,
	"./assets/Photos/Menu01042024/appretiser_edamame.jpeg": 1033,
	"./assets/Photos/Menu01042024/appretiser_prawn_cracker.jpeg": 2025,
	"./assets/Photos/Menu01042024/appretiser_prawn_tempura.jpeg": 3651,
	"./assets/Photos/Menu01042024/appretiser_prawn_toast.jpeg": 6514,
	"./assets/Photos/Menu01042024/appretiser_salt_pepper_calarmari.jpeg": 7851,
	"./assets/Photos/Menu01042024/appretiser_sweetchilli_chicken_wings.jpeg": 6366,
	"./assets/Photos/Menu01042024/appretiser_thai_chicken_wings.jpeg": 7870,
	"./assets/Photos/Menu01042024/appretiser_vegetable_spring_rolls.jpeg": 8448,
	"./assets/Photos/Menu01042024/curry_asia_villa_special_fried_rice.jpeg": 6444,
	"./assets/Photos/Menu01042024/curry_chicken_teriyaki.jpeg": 7153,
	"./assets/Photos/Menu01042024/curry_japanese_katsu.jpeg": 3154,
	"./assets/Photos/Menu01042024/curry_nasi_goreng.jpeg": 4763,
	"./assets/Photos/Menu01042024/curry_pakapong.jpeg": 6818,
	"./assets/Photos/Menu01042024/curry_sweet_sour.jpeg": 7887,
	"./assets/Photos/Menu01042024/curry_thai_green_curry.jpeg": 7074,
	"./assets/Photos/Menu01042024/curry_thai_massaman.jpeg": 1936,
	"./assets/Photos/Menu01042024/curry_thai_red_curry.jpeg": 6130,
	"./assets/Photos/Menu01042024/dessert_mango_passion.jpeg": 653,
	"./assets/Photos/Menu01042024/dessert_vanilla_mochi.jpeg": 6996,
	"./assets/Photos/Menu01042024/dessert_white_chocolate_pyramid.jpeg": 1885,
	"./assets/Photos/Menu01042024/drink_7up.jpeg": 7783,
	"./assets/Photos/Menu01042024/drink_coke.jpeg": 8497,
	"./assets/Photos/Menu01042024/drink_diet_coke.jpeg": 1466,
	"./assets/Photos/Menu01042024/drink_fanta.jpeg": 879,
	"./assets/Photos/Menu01042024/drink_sparkling.jpeg": 9574,
	"./assets/Photos/Menu01042024/drink_still.jpeg": 3357,
	"./assets/Photos/Menu01042024/extra_chilli_oil.jpeg": 1584,
	"./assets/Photos/Menu01042024/extra_crush_peanut.jpeg": 6012,
	"./assets/Photos/Menu01042024/extra_soy.jpeg": 5729,
	"./assets/Photos/Menu01042024/extra_sweet_chilli.jpeg": 1326,
	"./assets/Photos/Menu01042024/filenames.txt": 7438,
	"./assets/Photos/Menu01042024/noodle_dish_burmese_scissor.jpeg": 6157,
	"./assets/Photos/Menu01042024/noodle_dish_chiil_yaki_udon.jpeg": 7384,
	"./assets/Photos/Menu01042024/noodle_dish_chow_mein.jpeg": 9239,
	"./assets/Photos/Menu01042024/noodle_dish_pad_kee_mao.jpeg": 7100,
	"./assets/Photos/Menu01042024/noodle_dish_pad_see_ew.jpeg": 8356,
	"./assets/Photos/Menu01042024/noodle_dish_pad_thai.jpeg": 4305,
	"./assets/Photos/Menu01042024/noodle_dish_singapore_noodle.jpeg": 9090,
	"./assets/Photos/Menu01042024/noodle_soup_japanese_ramen.jpeg": 4990,
	"./assets/Photos/Menu01042024/noodle_soup_thom_kha_vermecilli.jpeg": 8265,
	"./assets/Photos/Menu01042024/noodle_soup_tom_yum_vermecilli.jpeg": 9393,
	"./assets/Photos/Menu01042024/noodle_soup_vietnamese_pho.jpeg": 3999,
	"./assets/Photos/Menu01042024/salad_seaweed.jpeg": 9859,
	"./assets/Photos/Menu01042024/salad_thai_crush_peanut.jpeg": 2785,
	"./assets/Photos/Menu01042024/side_dish_coconut_rice.jpeg": 5972,
	"./assets/Photos/Menu01042024/side_dish_egg_fried_rice.jpeg": 6603,
	"./assets/Photos/Menu01042024/side_dish_jasmine_rice.jpeg": 1875,
	"./assets/Photos/Menu01042024/side_dish_katsu_curry.jpeg": 6016,
	"./assets/Photos/Menu01042024/side_dish_mixed_vegetable.jpeg": 6976,
	"./assets/Photos/Menu01042024/side_dish_stir_fried_brocolli.jpeg": 1503,
	"./assets/Photos/Menu01042024/sip_miso.jpeg": 6713,
	"./assets/Photos/Menu01042024/sip_tom_kha.jpeg": 8057,
	"./assets/Photos/Menu01042024/sip_tom_yum.jpeg": 8286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7148;